<template>
  <perfect-scrollbar class="body-scrollbar" ref="scrollBar">
    <div class="title">{{ $t('sideMenu.title') }}</div>

    <span>
      <div class="subtitle">{{ $t('sideMenu.deviceTitle') }}</div>
      <div v-if="isMobileDeviceAndNotInAllowedList" class="unsupported-message">
        <p v-html="$t('deviceSelectionDisabled')"></p>
      </div>
      <div v-else-if="isWaitingForLesson" class="unsupported-message">
        <p v-html="$t('deviceNotificationBeforeLesson')"></p>
      </div>
      <DeviceSelection />
    </span>

    <div class="subtitle">{{ $t('sideMenu.virtualBgTitle') }}</div>
    <VirtualBackground v-if="!isSafariBrowser" />
    <div v-else class="unsupported-message">
      <p v-html="$t('vBackgroundUnavailable')"></p>
    </div>

    <template v-if="displayLanguageSettings">
      <div class="subtitle">{{ $t('sideMenu.langSettings.title') }}</div>
      <LanguageSelection />
    </template>

    <div class="subtitle">{{ $t('sideMenu.colorTitle') }}</div>
    <ThemeSelection />

    <div class="subtitle">{{ $t('sideMenu.otherTitle') }}</div>

    <a class="device-selection" :href="faqLink" target="_blank">
      <el-select class="faq-selection" popper-class="faq__sub-select" v-model="faqText">
      </el-select>
    </a>
  </perfect-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex';

import DeviceSelection from '@/components/Lesson/VideoChat/DeviceSelection';
import LanguageSelection from '@/components/Lesson/SideMenu/LanguageSelection';
import ThemeSelection from '@/components/Lesson/SideMenu/ThemeSelection';
import VirtualBackground from '@/components/Lesson/SideMenu/VirtualBackground';

export default {
  components: {
    DeviceSelection,
    LanguageSelection,
    ThemeSelection,
    VirtualBackground
  },
  computed: {
    ...mapGetters('uaParser', [
      'isSafariBrowser',
      'isMobileDevice',
      'isMobileDeviceAndNotInAllowedList'
    ]),
    ...mapGetters(['isStudent', 'isWaitingForLesson', 'displayLanguageSettings', 'isZipanService']),
    ...mapGetters('userOtherSetting', ['isTaiwanCountryId']),

    faqText() {
      return this.$t('sideMenu.faqTitle');
    },
    faqLink() {
      if (!this.isStudent) {
        return 'https://www.koseijyou.ph/portal/modules/admin/faqs/MyStageGuide.php';
      }

      if (this.isZipanService) {
        return 'https://zipanfaq.zendesk.com/hc/ja/categories/61242702965401-MyStage-Teams%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6';
      }

      return this.isTaiwanCountryId
        ? 'https://bizmates-taiwan.zendesk.com/hc/ja/sections/50157148523545-Mystage'
        : 'https://supportbot-admin.userlocal.jp/pages/cfedf72a8faaa713c095?q=MyStage%E3%81%AE%E6%A9%9F%E8%83%BD%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6%E7%9F%A5%E3%82%8A%E3%81%9F%E3%81%84%E3%81%A7%E3%81%99';
    }
  }
};
</script>

<style scoped src="@/assets/css/pc/side_menu.css"></style>
<style scoped src="@/assets/css/sp/side_menu.css"></style>

<style lang="scss" scoped>
.body-scrollbar {
  padding: 0px 15px 24px;
  @media screen and (max-width: 959px) {
    max-height: calc(100vh - 104px) !important;
  }
}
</style>
